import { useEffect } from 'react'
import { initWallet } from './SpotizContractHelper'

import Footer from './components/Footer'
import Header from './components/Header'
import Main from './components/Main'
import bg from './assets/background.png'
import AnimatedDots from './components/AnimatedDots'

const App = () => {
  
  useEffect(async () => {
    await initWallet()
  }, [])

  return (
    <div className="wrapper gradient-bg-wrap">
      <div className="min-h-screen  bg-[length:700px_auto] bg-no-repeat bg-[right_top_5rem] bg-fixed md-display" style={{ backgroundImage:`url('${bg}')` }} >
        <AnimatedDots />
        <div className='z-10 relative'>
          <Header />
          <Main/>
        </div>
       <Footer />
      </div>
    </div>
  )
}

export default App
